export const translations = {
  it: {
    nav: {
      home: "Home",
      calculator: "Calcolatore",
      dashboard: "Dashboard",
      marketplace: "Installatori",
      education: "Impara",
      grants: "Bandi",
      login: "Accedi",
      register: "Registrati",
      logout: "Esci",
      language: "Lingua",
    },
    hero: {
      eyebrow: "Energia solare, resa semplice",
      title_1: "Il tuo tetto",
      title_2: "vale una",
      title_3: "centrale solare.",
      subtitle: "Calcola il risparmio, monitora l'impianto, ricevi preventivi. Un'unica piattaforma per l'autonomia energetica.",
      cta_primary: "Calcola risparmio",
      cta_secondary: "Scopri come funziona",
    },
    features: {
      title: "Tutto il fotovoltaico. In un posto.",
      calc: { title: "Calcolatore ROI", desc: "Stima produzione, risparmio e payback in 60 secondi." },
      dash: { title: "Dashboard impianto", desc: "Monitora produzione oraria, mensile, CO2 evitata." },
      market: { title: "Preventivi verificati", desc: "Installatori certificati e valutati dalla community." },
      edu: { title: "Impara e scegli", desc: "Guide, glossario, incentivi fiscali sempre aggiornati." },
      ai: { title: "Consulente AI", desc: "Domande sul solare? Risposte immediate 24/7." },
      eco: { title: "Impatto reale", desc: "Ogni kWh solare pesa 385g di CO2 in meno." },
    },
    calculator: {
      title: "Calcolatore fotovoltaico",
      subtitle: "Inserisci i tuoi dati per una stima gratuita e immediata.",
      residential: "Residenziale",
      industrial: "Industriale",
      ground: "Terreno",
      monthly_kwh: "Consumo mensile (kWh)",
      monthly_kwh_industrial: "Consumo mensile azienda (kWh)",
      monthly_kwh_ground: "Consumo mensile impianto (kWh)",
      roof_area: "Superficie tetto disponibile (m²)",
      roof_area_industrial: "Superficie capannone/tetto (m²)",
      roof_area_ground: "Superficie terreno disponibile (m²)",
      location: "Città",
      orientation: "Orientamento tetto",
      price: "Prezzo energia (€/kWh)",
      cost_per_kw: "Costo sistema (€/kWp)",
      calculate: "Calcola",
      save: "Salva calcolo",
      results: "Risultati",
      recommended_kwp: "Potenza consigliata",
      annual_production: "Produzione annua",
      annual_savings: "Risparmio annuo",
      payback: "Payback",
      co2: "CO₂ evitata",
      panels: "Pannelli stimati",
      cost: "Investimento",
      monthly_chart: "Produzione mensile stimata",
      south: "Sud", east: "Est", west: "Ovest", north: "Nord",
      years: "anni",
    },
    dashboard: {
      title: "I tuoi impianti",
      add_plant: "Aggiungi impianto",
      no_plants: "Nessun impianto registrato. Aggiungi il primo per vedere la dashboard.",
      today: "Oggi",
      month: "Mese",
      year: "Anno",
      today_hourly: "Produzione oraria",
      last_30_days: "Ultimi 30 giorni",
      monthly_year: "Anno in corso",
      current_power: "Potenza attuale",
      self_consumption: "Autoconsumo",
      history: "Storico calcoli",
    },
    marketplace: {
      title: "Trova il tuo installatore",
      subtitle: "Aziende verificate, valutate dalla nostra community.",
      years_activity: "anni di attività",
      reviews: "recensioni",
      request_quote: "Richiedi preventivo",
      verified: "Verificato",
    },
    education: {
      title: "Impara sul fotovoltaico",
      subtitle: "Guide, glossario, incentivi. Tutto ciò che devi sapere.",
      read_min: "min di lettura",
    },
    auth: {
      login_title: "Accedi a SolarControl Minniti",
      register_title: "Crea il tuo account",
      email: "Email",
      password: "Password",
      name: "Nome",
      submit_login: "Accedi",
      submit_register: "Registrati",
      switch_to_register: "Non hai un account? Registrati",
      switch_to_login: "Hai già un account? Accedi",
    },
    chat: {
      title: "Consulente AI",
      placeholder: "Chiedi qualcosa sul fotovoltaico...",
      send: "Invia",
      welcome: "Ciao! Sono SolarControl Minniti, il tuo consulente solare. Come posso aiutarti?",
    },
    quote: {
      title: "Richiedi preventivo",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      address: "Indirizzo",
      monthly_kwh: "Consumo mensile (kWh)",
      notes: "Note",
      submit: "Invia richiesta",
      success: "Richiesta inviata! Ti contatteranno entro 48h.",
    },
    common: {
      loading: "Caricamento...",
      error: "Errore",
      save: "Salva",
      cancel: "Annulla",
      delete: "Elimina",
      close: "Chiudi",
    },
  },
  en: {
    nav: {
      home: "Home", calculator: "Calculator", dashboard: "Dashboard",
      marketplace: "Installers", education: "Learn", grants: "Grants", login: "Log in",
      register: "Sign up", logout: "Log out", language: "Language",
    },
    hero: {
      eyebrow: "Solar energy, made simple",
      title_1: "Your roof",
      title_2: "is worth a",
      title_3: "solar plant.",
      subtitle: "Calculate savings, monitor your plant, get quotes. One platform for energy independence.",
      cta_primary: "Calculate savings",
      cta_secondary: "See how it works",
    },
    features: {
      title: "All things solar. In one place.",
      calc: { title: "ROI Calculator", desc: "Estimate production, savings and payback in 60 seconds." },
      dash: { title: "Plant dashboard", desc: "Monitor hourly, monthly production and CO2 saved." },
      market: { title: "Verified quotes", desc: "Certified installers rated by the community." },
      edu: { title: "Learn and choose", desc: "Guides, glossary, updated tax incentives." },
      ai: { title: "AI Advisor", desc: "Solar questions? Instant answers 24/7." },
      eco: { title: "Real impact", desc: "Every solar kWh saves 385g of CO2." },
    },
    calculator: {
      title: "Photovoltaic calculator",
      subtitle: "Enter your details for a free, instant estimate.",
      residential: "Residential",
      industrial: "Industrial",
      ground: "Ground",
      monthly_kwh: "Monthly consumption (kWh)",
      monthly_kwh_industrial: "Monthly business consumption (kWh)",
      monthly_kwh_ground: "Monthly plant consumption (kWh)",
      roof_area: "Available roof area (m²)",
      roof_area_industrial: "Warehouse/roof area (m²)",
      roof_area_ground: "Available land area (m²)",
      location: "City",
      orientation: "Roof orientation",
      price: "Energy price (€/kWh)",
      cost_per_kw: "System cost (€/kWp)",
      calculate: "Calculate",
      save: "Save calculation",
      results: "Results",
      recommended_kwp: "Recommended power",
      annual_production: "Annual production",
      annual_savings: "Annual savings",
      payback: "Payback",
      co2: "CO₂ avoided",
      panels: "Estimated panels",
      cost: "Investment",
      monthly_chart: "Estimated monthly production",
      south: "South", east: "East", west: "West", north: "North",
      years: "years",
    },
    dashboard: {
      title: "Your plants",
      add_plant: "Add plant",
      no_plants: "No plants registered. Add your first one to see the dashboard.",
      today: "Today", month: "Month", year: "Year",
      today_hourly: "Hourly production",
      last_30_days: "Last 30 days",
      monthly_year: "Current year",
      current_power: "Current power",
      self_consumption: "Self-consumption",
      history: "Calculation history",
    },
    marketplace: {
      title: "Find your installer",
      subtitle: "Verified companies, rated by our community.",
      years_activity: "years active",
      reviews: "reviews",
      request_quote: "Request quote",
      verified: "Verified",
    },
    education: {
      title: "Learn about solar",
      subtitle: "Guides, glossary, incentives. All you need to know.",
      read_min: "min read",
    },
    auth: {
      login_title: "Log in to SolarControl Minniti",
      register_title: "Create your account",
      email: "Email", password: "Password", name: "Name",
      submit_login: "Log in", submit_register: "Sign up",
      switch_to_register: "No account? Sign up",
      switch_to_login: "Already have an account? Log in",
    },
    chat: {
      title: "AI Advisor",
      placeholder: "Ask something about solar...",
      send: "Send",
      welcome: "Hi! I'm SolarControl Minniti, your solar advisor. How can I help?",
    },
    quote: {
      title: "Request quote",
      name: "Full name", email: "Email", phone: "Phone",
      address: "Address", monthly_kwh: "Monthly consumption (kWh)",
      notes: "Notes", submit: "Send request",
      success: "Request sent! You'll be contacted within 48h.",
    },
    common: {
      loading: "Loading...", error: "Error", save: "Save",
      cancel: "Cancel", delete: "Delete", close: "Close",
    },
  },
  pl: {
    nav: {
      home: "Strona główna",
      calculator: "Kalkulator",
      dashboard: "Panel",
      marketplace: "Instalatorzy",
      education: "Edukacja",
      grants: "Dotacje",
      login: "Zaloguj się",
      register: "Zarejestruj się",
      logout: "Wyloguj się",
      language: "Język",
    },
    hero: {
      eyebrow: "Energia słoneczna, prosto",
      title_1: "Twój dach",
      title_2: "jest wart",
      title_3: "elektrowni słonecznej.",
      subtitle: "Oblicz oszczędności, monitoruj instalację, otrzymuj wyceny. Jedna platforma dla niezależności energetycznej.",
      cta_primary: "Oblicz oszczędności",
      cta_secondary: "Zobacz, jak to działa",
    },
    features: {
      title: "Wszystko o fotowoltaice. W jednym miejscu.",
      calc: { title: "Kalkulator ROI", desc: "Oszacuj produkcję, oszczędności i okres zwrotu w 60 sekund." },
      dash: { title: "Panel instalacji", desc: "Monitoruj godzinową i miesięczną produkcję oraz zaoszczędzone CO2." },
      market: { title: "Zweryfikowane wyceny", desc: "Certyfikowani instalatorzy oceniani przez społeczność." },
      edu: { title: "Ucz się i wybieraj", desc: "Przewodniki, słownik, aktualne ulgi podatkowe." },
      ai: { title: "Doradca AI", desc: "Pytania o fotowoltaikę? Odpowiedzi natychmiast 24/7." },
      eco: { title: "Realny wpływ", desc: "Każda słoneczna kWh oszczędza 385g CO2." },
    },
    calculator: {
      title: "Kalkulator fotowoltaiczny",
      subtitle: "Wprowadź swoje dane, aby uzyskać darmową, natychmiastową wycenę.",
      residential: "Mieszkalne",
      industrial: "Przemysłowe",
      ground: "Grunt",
      monthly_kwh: "Miesięczne zużycie (kWh)",
      monthly_kwh_industrial: "Miesięczne zużycie firmowe (kWh)",
      monthly_kwh_ground: "Miesięczne zużycie instalacji (kWh)",
      roof_area: "Dostępna powierzchnia dachu (m²)",
      roof_area_industrial: "Powierzchnia hali/dachu (m²)",
      roof_area_ground: "Dostępna powierzchnia gruntu (m²)",
      location: "Miasto",
      orientation: "Orientacja dachu",
      price: "Cena energii (€/kWh)",
      cost_per_kw: "Koszt systemu (€/kWp)",
      calculate: "Oblicz",
      save: "Zapisz obliczenie",
      results: "Wyniki",
      recommended_kwp: "Zalecana moc",
      annual_production: "Roczna produkcja",
      annual_savings: "Roczne oszczędności",
      payback: "Okres zwrotu",
      co2: "Uniknięte CO₂",
      panels: "Szacowane panele",
      cost: "Inwestycja",
      monthly_chart: "Szacowana produkcja miesięczna",
      south: "Południe", east: "Wschód", west: "Zachód", north: "Północ",
      years: "lat",
    },
    dashboard: {
      title: "Twoje instalacje",
      add_plant: "Dodaj instalację",
      no_plants: "Brak zarejestrowanych instalacji. Dodaj pierwszą, aby zobaczyć panel.",
      today: "Dziś", month: "Miesiąc", year: "Rok",
      today_hourly: "Produkcja godzinowa",
      last_30_days: "Ostatnie 30 dni",
      monthly_year: "Bieżący rok",
      current_power: "Aktualna moc",
      self_consumption: "Autokonsumpcja",
      history: "Historia obliczeń",
    },
    marketplace: {
      title: "Znajdź instalatora",
      subtitle: "Zweryfikowane firmy, oceniane przez naszą społeczność.",
      years_activity: "lat działalności",
      reviews: "recenzji",
      request_quote: "Poproś o wycenę",
      verified: "Zweryfikowany",
    },
    education: {
      title: "Ucz się o fotowoltaice",
      subtitle: "Przewodniki, słownik, zachęty. Wszystko, co musisz wiedzieć.",
      read_min: "min czytania",
    },
    auth: {
      login_title: "Zaloguj się do SolarControl Minniti",
      register_title: "Utwórz konto",
      email: "Email", password: "Hasło", name: "Imię",
      submit_login: "Zaloguj się", submit_register: "Zarejestruj się",
      switch_to_register: "Nie masz konta? Zarejestruj się",
      switch_to_login: "Masz już konto? Zaloguj się",
    },
    chat: {
      title: "Doradca AI",
      placeholder: "Zadaj pytanie o fotowoltaikę...",
      send: "Wyślij",
      welcome: "Cześć! Jestem SolarControl Minniti, Twój doradca fotowoltaiczny. Jak mogę pomóc?",
    },
    quote: {
      title: "Poproś o wycenę",
      name: "Imię i nazwisko", email: "Email", phone: "Telefon",
      address: "Adres", monthly_kwh: "Miesięczne zużycie (kWh)",
      notes: "Uwagi", submit: "Wyślij zapytanie",
      success: "Zapytanie wysłane! Skontaktujemy się w ciągu 48h.",
    },
    common: {
      loading: "Ładowanie...", error: "Błąd", save: "Zapisz",
      cancel: "Anuluj", delete: "Usuń", close: "Zamknij",
    },
  },
};
